export default "__VITE_ASSET__6aaacb53__"